import axios from "axios";
import { END_POINT } from "config/environment";
import { IGeneralProps } from "types";

export const handleClose = async ({
  id,
  reason,
  token,
  closeEndPointUrl,
}: IGeneralProps) => {
  const url = `${END_POINT.BASE_URL}/v1/${closeEndPointUrl}`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const data: any = {
    'id': id,
    'reason': reason
  };

  const response = await axios.post(url, data, config);
  return response;
};
